import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectAppEditable = (store: StoreSchema) => store.application.appEditable